import React from 'react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 border-t border-gray-200 mt-12 py-8 px-6">
      <div className="max-w-4xl mx-auto">
        <nav className="flex justify-center space-x-6 mb-6">
          <Link to="/disclaimer" className="text-sm text-gray-600 hover:text-gray-900">Disclaimer</Link>
          <Link to="/privacy" className="text-sm text-gray-600 hover:text-gray-900">Privacy</Link>
          <Link to="/terms" className="text-sm text-gray-600 hover:text-gray-900">Terms</Link>
        </nav>
        
        <div className="flex justify-center mb-6">
          <Link
            to="/contribute"
            className="bg-blue-600 text-white px-6 py-2 rounded-md font-semibold hover:bg-blue-700 transition-colors shadow-sm"
          >
            Share Data & Insights
          </Link>
        </div>
        
        <div className="text-center text-sm text-gray-600 pt-4 border-t border-gray-200">
          <p className="mb-2">
            <strong className="text-red-600">FOR RESEARCH PURPOSES ONLY!</strong>
          </p>
          <p>
            Peptide Now™ - Precision Vial Metrics Calculator
          </p>
          <p className="mt-1">
            © {currentYear} Peptide Now. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
